import Vue from 'vue';
import MetaInfo from 'vue-meta-info';
import App from './App.vue';
import router from './router';
import dayjs from 'dayjs';
import 'swiper/dist/css/swiper.css';
import '@/assets/common/common.less';
import '@/assets/common/quillEditor.css';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Tabs,
  TabPane,
  Pagination,
  Breadcrumb,
  BreadcrumbItem,
  Table,
  TableColumn,
  Input,
  Message,
  Popover,
  Select,
  Option,
} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import mavonEditor from "mavon-editor";
import '@/assets/common/mavonEditor.css';
Vue.use(mavonEditor);


Vue.use(MetaInfo);
Vue.use(Dropdown);
Vue.use(DropdownItem);
Vue.use(DropdownMenu);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Pagination);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Input);
Vue.use(Popover);
Vue.use(Select);
Vue.use(Option);
Vue.prototype.$message = Message;
Vue.prototype.$dayjs = dayjs;
Vue.config.productionTip = false;

Vue.prototype.briefName = function(name) {
  return name.replace(/^\d+\./, '').replace(/\.md$/, '');
}

Vue.mixin({
  methods: {
    redirect(path) {
      if(`${window.location.pathname}${window.location.search}` === path) return;
      window.location.href = path;
    }
  }
});

new Vue({
  router,
  render: h => h(App),
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')
